//https://cors-anywhere.herokuapp.com/

export const API_BASE_URL =
  "https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3";

//FIXME: remove this token
export const BEARER_TOKEN =
  "qRBZpqHn-tjqxOI8VLnQxaMvxLtIJ-tF0lXbyXaxCc4kBLKtI6LfdHWa3GzSqW9b-r1DABK3tIClLbG72gE2Ax011dF-jSBQgZ91upccJU26n_8-ag4QRUePKKkJYXYx";
